import { Category } from '@bepatient/category-store';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CategoryActions, CategoryActionTypes } from './category.actions';

interface CategoryState {
  category: Category;
}

export const categoryInitialState: CategoryState = {
  category: undefined
};

export function categoryReducer(
  state = categoryInitialState,
  action: CategoryActions
): CategoryState {
  switch (action.type) {
    case CategoryActionTypes.LOAD_CATEGORY:
      return { ...state, category: void 0 };

    case CategoryActionTypes.LOAD_CATEGORY_SUCCESS:
      return { ...state, category: action.payload };

    default:
      return state;
  }
}

const categoryState = createFeatureSelector<CategoryState>('category');

export const selectorCategoryCategory = createSelector(
  categoryState,
  state => state.category
);
